<template>
  <div class="card p-2">
    <b-link
      class="font-weight-bold d-block text-nowrap mr-3 mb-2"
      @click="mudarComponente()"
    >
      <el-button
        id="voltar-lista-aluno"
        style="border: none; background-color: transparent;"
        type="button"
        class="is-plain"
      >
        <i class="el-icon-back" />
        Alunos
      </el-button>
    </b-link>
    <b-modal
      id="modal-vincu-curso"
      ok-only
      ok-title="Salvar"
      centered
      size="lg"
      title="Vincular cursos"
      @ok="salvarCursosSelecionados"
    >
      <div>
        <!-- Lista de cursos com checkboxes -->
        <div
          v-for="curso in cursosFiltrados"
          :key="curso.id"
        >
          <input
            :id="`curso-${curso.id}`"
            type="checkbox"
            :checked="cursosSelecionados.includes(curso.id)"
            @change="atualizarCursosSelecionados(curso.id)"
          >
          <span
            class="font-weight-bold"
            :for="`curso-${curso.id}`"
          >{{ curso.nome }}</span>
        </div>
      </div>
    </b-modal>

    <b-media class="mb-2 ">
      <div class="mt-3 d-flex justify-content-center">
        <input-file-custom
          id="input-file"
          :image-rendered="renderizaImagem"
          :rendered-image="aluno.user_photo_url"
          @atualizarImagem="updatedImagem($event)"
        />
      </div>
    </b-media>

    <!-- User Info: Input Fields -->
    <b-form>
      <b-row>
        <!-- Field: Username -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Nome"
            label-for="username"
          >
            <b-form-input
              id="username"
              v-model="aluno.user_name"
            />
          </b-form-group>
        </b-col>
        <!-- Field: Email -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Email"
            label-for="email"
          >
            <b-form-input
              id="email"
              v-model="aluno.user_email"
              type="email"
              disabled
            />
          </b-form-group>
        </b-col>

        <!-- Field: Status -->
        <b-col
          cols="12"
          md="6"
        >

          <b-form-group
            label="Status"
            label-for="user-status"
          >
            <v-select
              v-model="aluno.user_ativo"
              :options="statusOptions"
              :reduce="p => p.value"
              label="label"
            />
            <b-button
              class="bg-danger mt-3"
              style="border: none"
              @click="salvarAlterações()"
            >
              Salvar Alterações
            </b-button>
          </b-form-group>

        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Telefone"
            label-for="user-status"
          >
            <b-form-input
              id="user-phone"
              v-model="aluno.user_phone"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>

    <!-- PERMISSION TABLE -->
    <b-card
      no-body
      class="border mt-1"
    >
      <b-row class="p-1">
        <b-col
          class="my-1 d-flex justify-content-start"
        >
          <span class="align-middle ml-50 font-medium-2">Cursos desse Aluno</span>

        </b-col>
        <b-col

          class="my-1 d-flex justify-content-end"
        >

          <b-button
            v-b-modal.modal-vincu-curso
            class="bg-danger"
            style="border: none"
          >
            + Curso
          </b-button>
        </b-col></b-row>

      <b-table
        striped
        responsive
        class="mb-0"
        :items="cursosXaluno"
        :fields="fields"
      >
        <template #cell(excluir)="data">
          <b-button @click="deleteVinculo(data.item.id)">
            <feather-icon icon="TrashIcon" />
          </b-button>
        </template>

      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BButton,
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BTable,
  BCard,
  BCardHeader,
  BCardTitle,
  BFormCheckbox,
  BFormTextarea, BModal,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { useApi, useApiAWS } from '@/composables/useApi'
import InputFileCustom from '@/views/App/Cursos/InputFileCustom.vue'

const apiAws = useApiAWS()
const apiBack = useApi()
export default {
  components: {
    BModal,
    BFormTextarea,
    InputFileCustom,
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    vSelect,
  },
  data() {
    return {
      aluno: [],
      cursos: [],
      renderizaImagem: true,
      fotoInicial: [],
      cursosSelecionados: [],
      cursosXaluno: [],
      statusOptions: [
        { value: 1, label: 'Ativo' },
        { value: 0, label: 'Inativo' },
      ],
      fields: [
        // {
        //   key: 'id', label: 'Id',
        // },
        { key: 'Nome_Curso' },
        { key: 'excluir', label: 'Excluir' },
      ],
      perPage: 5,
      pageOptions: [3, 5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      alunoId: this.$route.params.id,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
    }
  },
  computed: {
    cursosFiltrados() {
      // Filtra os cursos que não estão presentes na propriedade cursosXaluno
      return this.cursos.filter(curso => !this.cursosXaluno.some(cursoXaluno => cursoXaluno.ID_Curso === curso.id))
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    getUserData: {
      get() {
        const newUserData = JSON.parse(localStorage.getItem('userData'))
        if (newUserData !== null) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.domainUser = newUserData.user_domain
          return newUserData
        }
        return {}
      },
      set(value) {
        localStorage.setItem('userData', JSON.stringify(value))
      },
    },
  },
  async mounted() {
    await this.listarCurso()
    await this.buscarAluno()
    await this.buscarCursosXAluno()

    // Set the initial number of items
    this.totalRows = this.cursosXaluno.length
  },
  methods: {
    async salvarAlterações() {
      await this.uploadCapaCurso()
      this.$message({
        type: 'success',
        message: 'Salvo com sucesso',
      })
      await apiBack.put(`/editAlunoById/?id=${this.alunoId}`, {
        nome: this.aluno.user_name,
        email: this.aluno.user_email,
        phone: this.aluno.user_phone,
        foto: this.aluno.user_photo_url,
        filekey: this.aluno.user_perfil_file_key,
        status: this.aluno.user_ativo,
      })
        .then(() => {
          this.buscarDadosCurso()
          this.buscarAluno()
        })
        .catch(err => console.error(err))
    },
    async uploadCapaCurso() {
      const formData = new FormData()
      formData.append('video', this.aluno.user_photo_url)
      formData.append('caminho', `${this.aluno.user_file_key}`)
      await apiAws.post('/thumb', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(async response => {
        console.log(response)
        this.aluno.user_photo_url = response.data.data.fileUrl
        this.aluno.user_perfil_file_key = response.data.data.key_filename
      }).catch(err => {
        console.log(err)
      })
    },
    updatedImagem(event) {
      this.aluno.user_photo_url = event
    },
    mudarComponente() {
      return this.$router.push('/cadAluno')
    },
    atualizarCursosSelecionados(idCurso) {
      // Verifica se o curso já está no array cursosSelecionados
      const indexCurso = this.cursosSelecionados.indexOf(idCurso)

      // Se o curso já estiver selecionado, remove-o do array
      if (indexCurso !== -1) {
        this.cursosSelecionados.splice(indexCurso, 1)
      } else {
        // Caso contrário, adiciona-o ao array
        this.cursosSelecionados.push(idCurso)
      }
    },
    salvarCursosSelecionados() {
      // Extrai os IDs dos cursos marcados do array cursosSelecionados
      const idsCursosSelecionados = this.cursosSelecionados

      // Chama a função para salvar os IDs dos cursos selecionados
      this.salvarIdsCursos(idsCursosSelecionados)
    },
    async salvarIdsCursos(idsCursos) {
      // Faça aqui o que precisa ser feito com os IDs dos cursos selecionados
      // Por exemplo, envie os IDs para o servidor ou realize alguma outra ação.
      await apiBack.post('/createCursoXAluno', {
        id_aluno: this.alunoId,
        id_curso: idsCursos,
      })
        .then(() => {
          this.cursosSelecionados = []
          this.buscarCursosXAluno()
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })
        .catch(err => console.error(err))
      console.log('IDs dos cursos selecionados:', idsCursos)
    },
    async listarCurso() {
      await apiBack.get(`/getCursosById?id=${this.getUserData.id}`)
        .then(data => {
          this.cursos = data.data
        })
        .catch(err => console.error(err))
    },
    async buscarAluno() {
      await apiBack.get(`/usuario/${this.alunoId}`)
        .then(data => {
          this.aluno = data.data[0]
          this.fotoInicial = data.data[0].user_photo_url
          if (data.data[0].user_photo_url === null) {
            this.renderizaImagem = false
          } else {
            this.renderizaImagem = true
          }
        })
        .catch(err => console.error(err))
    },
    async buscarCursosXAluno() {
      await apiBack.get(`/getAlunosXCursos?id=${this.alunoId}`)
        .then(data => {
          console.log(data.data)
          this.cursosXaluno = data.data
          this.cursosSelecionados = []
        })
        .catch(err => console.error(err))
    },
    async deleteVinculo(id) {
      console.log('DELETADO O VINCULO', id)
      await apiBack.delete(`/deleteAlunoCurso?id=${id}`)
        .then(() => {
          this.buscarCursosXAluno()
        })
        .catch(err => console.error(err))
    },

    // async deletarCurso() {
    //   await apiBack.delete(`/deleteCurso?id=${this.cursoSelecionado}`)
    //     .then(data => {
    //       console.log(data)
    //       this.listarCurso()
    //       this.$message({
    //         type: 'success',
    //         message: 'Deletado com sucesso',
    //       })
    //     })
    //     .catch(err => console.error(err))
    // },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    // async salvarCurso() {
    //   await this.uploadCapaCurso()
    //   console.log('SALVAR CURSO')
    //   console.log('NOME CURSO', this.nomeCursoNOVO)
    //   console.log('Descricao CURSO', this.descricaoCursoNOVO)
    //   console.log('IMAGEM', this.capa)
    //   await apiBack.post('/createCurso', {
    //     nome: this.nomeCursoNOVO,
    //     descricao: this.descricaoCursoNOVO,
    //     capa: this.capa,
    //     status: 1,
    //     id_user: this.getUserData.id,
    //   })
    //     .then(() => {
    //       this.listarCurso()
    //       this.$message({
    //         type: 'success',
    //         message: 'Salvo com sucesso',
    //       })
    //     })
    //     .catch(err => console.error(err))
    // },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
